// extracted by mini-css-extract-plugin
export default {"homeAdvertList":"c-c_cU","homeAdvertList__cardListContainer":"c-c_cV","homeAdvertList__loadMoreContainer":"c-c_cW"};